import { buildClientDisplayName } from './serviceOptions';

const toText = (value = '') => String(value || '').trim();

const buildAddressText = (input = {}) => [
  input?.address,
  input?.apartment,
  input?.locality,
  input?.partido,
  input?.province,
  input?.postalCode,
].map((part) => toText(part)).filter(Boolean).join(', ');

export const buildServiceAddressText = (input = {}) => buildAddressText(input);

export const buildContactLocationOptions = (contacts = []) => {
  const options = [];

  contacts.forEach((contact) => {
    const contactName = buildClientDisplayName(contact);
    const addresses = Array.isArray(contact?.addresses) ? contact.addresses : [];

    addresses.forEach((address, index) => {
      const addressText = buildAddressText(address);
      if (!addressText) return;

      options.push({
        id: `contact:${contact.id}:${index}`,
        source: 'contact',
        label: contactName,
        address: addressText,
        locality: toText(address?.locality),
        province: toText(address?.province),
        postalCode: toText(address?.postalCode),
        latlng: address?.latlng || null,
        contactId: contact.id,
        contactName,
        searchText: `${contactName} ${addressText}`.toLowerCase(),
      });
    });
  });

  return options;
};

export const buildSharedLocationOptions = (locations = []) =>
  locations.map((location) => {
    const label = toText(location?.label || location?.name || 'Destino guardado');
    const address = buildAddressText(location);
    return {
      id: `shared:${location.id}`,
      source: 'shared',
      label,
      address,
      locality: toText(location?.locality),
      province: toText(location?.province),
      postalCode: toText(location?.postalCode),
      latlng: location?.latlng || null,
      locationId: location.id,
      searchText: `${label} ${address}`.toLowerCase(),
    };
  });

export const buildServiceLocationOptions = ({ contacts = [], sharedLocations = [] }) => {
  const all = [
    ...buildContactLocationOptions(contacts),
    ...buildSharedLocationOptions(sharedLocations),
  ];

  const deduped = [];
  const seen = new Set();
  all.forEach((option) => {
    const key = `${toText(option.label).toLowerCase()}::${toText(option.address).toLowerCase()}`;
    if (!option.address || seen.has(key)) return;
    seen.add(key);
    deduped.push(option);
  });

  return deduped.sort((a, b) => `${a.label} ${a.address}`.localeCompare(`${b.label} ${b.address}`, 'es'));
};

export const createManualLocationState = () => ({
  optionId: '',
  mode: 'existing',
  label: '',
  address: '',
  locality: '',
  province: '',
  postalCode: '',
  lat: '',
  lng: '',
  saveToSharedBase: true,
  contactType: 'cliente',
});

export const buildLocationSnapshotFromOption = (option = null) => {
  if (!option) return null;
  return {
    source: option.source,
    optionId: option.id,
    label: option.label,
    address: option.address,
    locality: option.locality || '',
    province: option.province || '',
    postalCode: option.postalCode || '',
    latlng: option.latlng || null,
    contactId: option.contactId || '',
    contactNameSnapshot: option.contactName || '',
    locationId: option.locationId || '',
  };
};

export const buildLocationSnapshotFromManual = (state = {}) => {
  const lat = Number(state?.lat);
  const lng = Number(state?.lng);
  const hasCoords = Number.isFinite(lat) && Number.isFinite(lng);

  return {
    source: 'manual',
    label: toText(state?.label || state?.address || 'Destino manual'),
    address: toText(state?.address),
    locality: toText(state?.locality),
    province: toText(state?.province),
    postalCode: toText(state?.postalCode),
    latlng: hasCoords ? { lat, lng } : null,
    contactType: toText(state?.contactType || 'cliente') || 'cliente',
  };
};
